// Typed numbers for the decimal-keypad fields (ui/stepper.jsx and the
// Training logging sheet): the field keeps the person's text; these read
// it and move it by a step. Kept out of the component file (react-refresh).

const EPS = 1e-9;
const tidy = (value) => Math.round(value * 10000) / 10000;

/**
 * "135" → 135, "62,5" → 62.5 (a comma keypad), "135." → 135; empty or not
 * a number → null.
 */
export function parseDecimal(text) {
  if (typeof text === "number") return Number.isFinite(text) ? text : null;
  if (typeof text !== "string") return null;
  const cleaned = text.trim().replace(",", ".");
  if (cleaned === "" || !/^[-+]?(\d+\.?\d*|\.\d+)$/.test(cleaned)) return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
}

const clamp = (value, min, max) => {
  let out = value;
  if (min !== undefined && min !== null) out = Math.max(min, out);
  if (max !== undefined && max !== null) out = Math.min(max, out);
  return out;
};

/**
 * One step up (`direction` 1) or down (−1) from `value`, landing on the
 * step's grid — a typed 132 by 5 goes up to 135 and down to 130, not to
 * 137 / 127 — then held within [min, max]. An empty or unreadable value
 * starts from `min` (or 0): up gives the first step, down stays put.
 */
export function stepDecimal(value, step, direction, { min, max } = {}) {
  const current = parseDecimal(value);
  if (!(step > 0)) return current;
  if (current === null) {
    const start = min ?? 0;
    return clamp(tidy(direction > 0 ? start + step : start), min, max);
  }
  const n =
    direction > 0
      ? Math.floor(current / step + EPS) + 1
      : Math.ceil(current / step - EPS) - 1;
  return clamp(tidy(n * step), min, max);
}
